import { all } from 'redux-saga/effects';
import { loadingBarSagas } from './LoadingBar/loadingBarSagas';

export function* featuresSagas() {
  yield all([loadingBarSagas()]);
}
